import { alpha, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'icon-box',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      height: '100%',
      background: alpha(theme.palette.primary.light, 0.1),
      borderRadius: 8,
      padding: theme.spacing(3),
      transition: 'all .3s',
      '&:hover $title': {
        color: theme.palette.secondary.main,
      },
    },
    sizeSmall: {
      padding: theme.spacing(2),
      '& $icon': {
        marginBottom: theme.spacing(1),
        width: 40,
        height: 40,
      },
    },
    variantLight: {
      background: alpha(theme.palette.primary.light, 0.05),
      '&:hover': {
        background: alpha(theme.palette.primary.light, 0.1),
      },
    },
    icon: {
      marginBottom: theme.spacing(2),
      width: 48,
      height: 48,
    },
    title: {
      transition: 'all .3s',
    },
  }),
  options
);

export default useStyles;
